
const createActionName =
    require('../util').createActionName('session');

export const RECEIVE_SESSION_STARTED = createActionName('RECEIVE_SESSION_STARTED');
export const SET_LAST_ACTIVE = createActionName('SET_LAST_ACTIVE');
export const SET_SESSION_ALERT_ACTIVE = createActionName('SET_SESSION_ALERT_ACTIVE');
export const SET_SESSION_ALERT_INACTIVE = createActionName('SET_SESSION_ALERT_INACTIVE');

export const receiveSessionStarted = (payload) => {
    return {
        type: RECEIVE_SESSION_STARTED,
        payload,
    }
};

export const setLastActive = (payload) => {
    return {
        type: SET_LAST_ACTIVE,
        payload,
    }
};

export const setSessionAlertActive = () => {
    return {
        type: SET_SESSION_ALERT_ACTIVE,
    }
};

export const setSessionAlertInactive = () => {
    return {
        type: SET_SESSION_ALERT_INACTIVE,
    }
};

